import { MediumFormRow } from 'framework/ui/layout';
import { useEffect } from 'react';
import { DefaultInputPropTypes, NumberInput, useInputHelper, EnumDropdown } from 'framework/form';
import VacancyOfficeDropdown from 'domain/recruiting/vacancy/shared/input/VacancyOfficeDropdown';
import { getLastSource } from 'framework/utils';
import { VACANCY_EMPLOYEE_CONTRACT_TYPES_NO_INTERNSHIP } from '../vacancyService';
import { CurrencyDropdown } from 'domain/shared/core/input';

const ExpectedCompensationInput = (props: DefaultInputPropTypes<any>) => {
  const { getSource, getRawOnChangeCallback, getValue } = useInputHelper(props);
  const expectedCompensation = getValue() || {};
  const rawOnChangeCallback = getRawOnChangeCallback() || (() => {});

  const source = getSource();

  const onChangeCallback = (value: { [x: string]: any }) => {
    rawOnChangeCallback({
      [source]: {
        ...expectedCompensation,
        ...getLastSource(value),
      },
    });
  };

  useEffect(() => {
    if (!getValue()) {
      rawOnChangeCallback({
        [source]: {},
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <MediumFormRow>
        <VacancyOfficeDropdown
          source={`${source}.office`}
          value={expectedCompensation.office}
          label="Location (Office)"
          onChangeCallback={onChangeCallback}
        />
        <EnumDropdown
          options={VACANCY_EMPLOYEE_CONTRACT_TYPES_NO_INTERNSHIP}
          source={`${source}.contractType`}
          value={expectedCompensation.contractType}
          label="Contract type"
          placeholder="Select contract type"
          onChangeCallback={onChangeCallback}
        />
        <NumberInput
          source={`${source}.valueFrom`}
          value={expectedCompensation.valueFrom}
          label="Value From"
          onChangeCallback={onChangeCallback}
        />
        <NumberInput
          source={`${source}.valueTo`}
          value={expectedCompensation.valueTo}
          label="Value To"
          onChangeCallback={onChangeCallback}
        />
        <CurrencyDropdown
          source={`${source}.currency`}
          value={expectedCompensation.currency}
          label="Currency"
          onChangeCallback={onChangeCallback}
        />
      </MediumFormRow>
    </>
  );
};

export default ExpectedCompensationInput;
